export let PackagePickerSteps = /*#__PURE__*/function (PackagePickerSteps) {
  PackagePickerSteps["SELECT_PLAN"] = "select-plan";
  PackagePickerSteps["SELECT_CYCLE"] = "select-cycle";
  PackagePickerSteps["CHECKOUT"] = "checkout";
  PackagePickerSteps["ANY"] = "*";
  return PackagePickerSteps;
}({});

// please don't change type - https://wix.atlassian.net/browse/PREM-13075

export let SiteAuthorization = /*#__PURE__*/function (SiteAuthorization) {
  SiteAuthorization["AUTHORIZED"] = "authorized";
  SiteAuthorization["UNAUTHORIZED"] = "unauthorized";
  return SiteAuthorization;
}({});
// Copied from @wix/ambassador-billing-checkout-v1-context (can't import — broken exports in v1.0.46+)
// Source: https://github.com/wix-private/metro-packages/blob/master/packages/ambassador/billing-checkout-v1-context/types.impl.ts
export let InvoiceStatus = /*#__PURE__*/function (InvoiceStatus) {
  InvoiceStatus["UNKNOWN"] = "UNKNOWN";
  InvoiceStatus["DRAFT"] = "DRAFT";
  InvoiceStatus["PAID"] = "PAID";
  InvoiceStatus["VOID"] = "VOID";
  InvoiceStatus["REFUNDED"] = "REFUNDED";
  InvoiceStatus["DECLINED"] = "DECLINED";
  InvoiceStatus["PAYMENT_IN_PROGRESS"] = "PAYMENT_IN_PROGRESS";
  return InvoiceStatus;
}({});

// TODO: Move elsewhere, it's api client related
//# sourceMappingURL=types.js.map